export default "__VITE_ASSET__C$pQTNT6__"